module.exports = __webpack_public_path__ + "img/calendar-lines-pen-solid.110f132b.svg";